import { URL_FILES } from './envs'

export const UNDUE_PAYMENT_DOCUMENT_URL = `${URL_FILES}termo_pagamento_trocado.pdf`

export const WIFI_BEST_PRACTICES_URL = `${URL_FILES}GUIA_DO_USUARIO_WI-FI.pdf`
